export const UPDATE_RNR_PAGENO = 'UPDATE_RNR_PAGENO';
export const UPDATE_DETAILS_STATIC_DATA = 'UPDATE_DETAILS_STATIC_DATA';
export const UPDATE_DETAILS_HERMES_DATA = 'UPDATE_DETAILS_HERMES_DATA';
export const UPDATE_DETAILS_STATIC_FETCH_STATUS = 'UPDATE_DETAILS_STATIC_FETCH_STATUS';
export const UPDATE_OPEN_CATEGORIZED_AMENITIES = 'UPDATE_OPEN_CATEGORIZED_AMENITIES';
export const UPDATE_DETAILS_HERMES_FETCH_STATUS = 'UPDATE_DETAILS_HERMES_FETCH_STATUS';
export const UPDATE_CURRENT_ROOM = 'UPDATE_CURRENT_ROOM';
export const UPDATE_DETAILS_CONFIG = 'UPDATE_DETAILS_CONFIG';
export const UPDATE_UGC_IMAGES = 'UPDATE_UGC_IMAGES';
export const RESET_DETAILS_DATA = 'RESET_DETAILS_DATA';
export const UPDATE_SAFETY_HYGIENE_MEDIA_DATA = 'UPDATE_SAFETY_HYGIENE_MEDIA_DATA';
// hotel policys
export const UPDATE_HOTEL_POLICY_LIST = 'UPDATE_HOTEL_POLICY_LIST';
export const UPDATE_HOTEL_POLICY_ADDITIONAL_DATA = 'UPDATE_HOTEL_POLICY_ADDITIONAL_DATA';
export const UPDATE_HOTEL_POLICY_ERROR = 'UPDATE_HOTEL_POLICY_ERROR';
export const UPDATE_HOTEL_POLICY_FETCH_STATUS = 'UPDATE_HOTEL_POLICY_FETCH_STATUS';

// similar hotels
export const UPDATE_SIMILAR_HOTELS_DATA = 'UPDATE_SIMILAR_HOTELS_DATA';
export const UPDATE_SIMILAR_HOTELS_ERROR = 'UPDATE_SIMILAR_HOTELS_ERROR';
export const UPDATE_SIMILAR_HOTELS_FETCH_STATUS = 'UPDATE_SIMILAR_HOTELS_FETCH_STATUS';

// About property
export const UPDATE_ABOUT_PROPERTY = 'UPDATE_ABOUT_PROPERTY';

// selected hotel
export const UPDATE_SELECTED_PROPERTY = 'UPDATE_SELECTED_PROPERTY';
export const UPDATE_DETAILS_PAGE_BASE_URL_DATA = 'UPDATE_DETAILS_PAGE_BASE_URL_DATA';

// selected room
export const UPDATE_SELECTED_ROOM_DATA = 'UPDATE_SELECTED_ROOM_DATA';
export const RESET_SELECTED_ROOM_DATA = 'RESET_SELECTED_ROOM_DATA';

export const UPDATE_STATIC_DATA_FETCH_STATUS = 'UPDATE_STATIC_DATA_FETCH_STATUS';
